import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Bell } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const NotifyButton = ({ deal, size = "sm" }) => {
  const { isMember } = useAuth();
  const navigate = useNavigate();
  const [watching, setWatching] = useState(false);

  useEffect(() => {
    if (!isMember) return;
    api.get("/watchlist/me").then(({ data }) => setWatching(data.includes(deal.id))).catch(() => {});
  }, [isMember, deal.id]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isMember) { navigate("/join"); return; }
    const { data } = await api.post(`/deals/${deal.id}/watch`);
    setWatching(data.watching);
    toast.success(data.watching ? "You'll be emailed the second this drops." : "Alert removed.");
  };

  const cls = size === "lg"
    ? "w-full py-4 text-xl flex items-center justify-center gap-3"
    : "px-4 py-2 text-sm flex items-center gap-2";

  return (
    <button
      type="button"
      data-testid={`notify-me-button-${deal.slug}`}
      onClick={toggle}
      className={`${watching ? "btn-industrial" : "btn-ghost-industrial"} ${cls}`}
    >
      {watching ? <BellRing size={size === "lg" ? 18 : 14} /> : <Bell size={size === "lg" ? 18 : 14} />}
      {watching ? "ALERT SET" : "NOTIFY ME"}
    </button>
  );
};
